import { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axiosInstance from '../../../../../../services/axios/axios';

//param @app : AppManagementModel
//param @setApp : function
const UserNameTypeDropdown = ({ app, setApp }) => {
	//drop down component, options sourced from T_Username_Type

	const [options, setOptions] = useState([]);

	useEffect(() => {
		GetUserNameTypeOptions().then(options => {
			setOptions(options);
		});
	}, []);

	//set username type to first option in the dropdown if it is not already assigned
	//or else it wont be assigned until the dropdown changes
	useEffect(() => {
		if (
			app.appAux.userNameTypeID === null ||
			app.appAux.userNameTypeID === undefined
		) {
			setApp({
				...app,
				appAux: {
					...app.appAux,
					userNameTypeID: options[0]?.ID,
				},
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options]);

	const handleChange = e => {
		setApp({
			...app,
			appAux: {
				...app.appAux,
				userNameTypeID: e.target.value,
			},
		});
	};

	return (
		<Select
			labelId='UserNameTypeDropdown'
			id='UserNameTypeDropdown'
			value={
				app?.appAux?.userNameTypeID
					? app.appAux.userNameTypeID
					: options[0]?.ID
					? options[0]?.ID
					: ''
			}
			label='UserNameType'
			onChange={handleChange}
		>
			{options.map(option => {
				return (
					<MenuItem key={option.ID} value={option.ID}>
						{option.Full}
					</MenuItem>
				);
			})}
		</Select>
	);
};

export default UserNameTypeDropdown;

const GetUserNameTypeOptions = async () => {
	try {
		const response = await axiosInstance.get(
			`api/ApplicationManagement/misc/getUserNameTypes`
		);
		return response.data;
	} catch (ex) {
		console.error(
			'Unable to fetch username Types for UserName Type dropdown: ' + ex
		);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};
